<template>
  <UAlert
    :title="t('views.cottage-prices.readyNoVacancy.title')"
    color="error"
    variant="soft"
    class="mb-4"
    icon="i-heroicons-x-circle"
    :actions="[
      {
        label: t('views.cottage-prices.readyNoVacancy.action1'),
        color: 'neutral',
        variant: 'solid',
        onClick: () => emit('button-click'),
      },
      {
        label: t('views.cottage-prices.readyNoVacancy.action2'),
        color: 'neutral',
        variant: 'outline',
        to: routes().cottageList({
          l: slug,
          d: `${route.query.dateIn},${route.query.dateOut}`,
          c: route.query.capacity as string,
        }),
      },
    ]"
  />
</template>
<script setup lang="ts">
interface propsInterface {
  slug: string
}
defineProps<propsInterface>()
const emit = defineEmits(['button-click'])

const route = useRoute()
</script>
